/**
 * Animation domino pour les blocs .wp-block-post et les listes
 * Fait apparaître les éléments avec un effet domino (décalé) depuis le bas
 * 
 * @package g3w-theme
 * @author Gianito - G3W
 */

document.addEventListener('DOMContentLoaded', () => {
    // Sélectionner tous les conteneurs avec la classe .is-animated
    const queryBlocks = document.querySelectorAll('.wp-block-query.is-animated');
    const listBlocks = document.querySelectorAll('.wp-block-list.is-animated');

    // Fonction pour traiter l'animation domino
    function setupDominoAnimation(container, selector) {
        const elements = container.querySelectorAll(selector);

        if (elements.length === 0) {
            return; // Passer au conteneur suivant si aucun élément
        }

        // Configuration de l'Intersection Observer
        const observer = new IntersectionObserver((entries, observer) => { // Self-reference observer for unobserving
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    // Trouver l'index de l'élément dans la liste des éléments de ce conteneur
                    const elementIndex = Array.from(elements).indexOf(entry.target);

                    // Décalage progressif pour l'effet "domino"
                    setTimeout(() => {
                        entry.target.classList.add('reveal');
                    }, elementIndex * 80); // Délai réduit pour une animation plus rapide et naturelle

                    // Observer une seule fois
                    observer.unobserve(entry.target);
                }
            });
        }, {
            threshold: 0.05, // Se déclenche quand 5% de l'élément est visible
            rootMargin: '0px 0px 200px 0px' // Se déclenche 200px avant que l'élément entre dans le viewport
        });

        // Observer chaque élément de ce conteneur
        elements.forEach(element => {
            observer.observe(element);
        });
    }

    // Traiter les blocs de posts
    queryBlocks.forEach(queryBlock => {
        setupDominoAnimation(queryBlock, '.wp-block-post');
    });

    // Traiter les listes
    listBlocks.forEach(listBlock => {
        setupDominoAnimation(listBlock, 'li');
    });
}); 